import { render } from "./MyPods.vue?vue&type=template&id=12d3b566&scoped=true"
import script from "./MyPods.vue?vue&type=script&lang=js"
export * from "./MyPods.vue?vue&type=script&lang=js"

import "./MyPods.vue?vue&type=style&index=0&id=12d3b566&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d3b566"]])

export default __exports__